export const projectStatusPolicyTag = 'ProjectStatusPolicy:';
